import { combineReducers } from 'redux';

import transactions from './linkedkey';

const reducer = combineReducers({
  [transactions.name]: transactions.reducer,
});

export default reducer;
